import httpClient from "../../api/httpClient";
import PedidoImportacao from "../classes/PedidoImportacao";
import Usuario from "../classes/Usuario";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "POST", rota: "PedidoImportacao/Adicionar" },
  { method: "PUT", rota: "PedidoImportacao/Atualizar" },
  { method: "DELETE", rota: "PedidoImportacao/Apagar" },
  { method: "GET", rota: "PedidoImportacao/RecuperarTodos" },
  { method: "GET", rota: "PedidosImportacaoPorFornecedor/" },
  { method: "POST", rota: "PedidoImportacao/Integrar" },
  { method: "PUT", rota: "PedidoImportacao/Atualizar/Lote" },
];

const cacheKey: string = "PedidoImportacaoCache";

const apiServico: String = "PEDIDOS"

class PedidoImportacaoDataSet extends httpClient {

  constructor() {
    super(String(apiServico));
  }

  async Adicionar(value: PedidoImportacao): Promise<PedidoImportacao> {
    const result = await super.post(calls[0].rota, value);
    return result;
  }

  async Atualizar(value: PedidoImportacao) {
    const result = await super.put(calls[1].rota, value);
    return result;
  }

  async AtualizarLote(value: (PedidoImportacao | undefined)[]) {
    const result = await super.put(calls[6].rota, value);
    return result;
  }

  async Apagar(value: PedidoImportacao) {
    const result = await super.delete(calls[2].rota, value);
    return result;
  }

  async ListarAtivos(): Promise<PedidoImportacao[]> {
    return await super.Get(calls[3].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async ListarAtivosPorCodFornecedorSap(codigoFornecedorSap: Number): Promise<PedidoImportacao[]> {
    return await super.Get(calls[4].rota + codigoFornecedorSap)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async Integrar(value: PedidoImportacao[]) {
    const usuario: Usuario = JSON.parse(String(localStorage.getItem("UsuarioCache")));
    let url: string = `${calls[5].rota}/${usuario.email}`;
    const result = await super.post(url, value);
    return result;
  }

  getKeyCache(): string {
    return cacheKey;
  }

  ListarFromCache(): PedidoImportacao[] {
    let result: PedidoImportacao[] = JSON.parse(cacheKey);
    return result;
  }

  AdicionarListaAoCache(value: PedidoImportacao[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

}
export default PedidoImportacaoDataSet;

